module.exports = __webpack_public_path__ + "img/finland-lung-cancer-female.548b71ca.png";